/* eslint-disable no-shadow */
export enum FeatureFlagName {
  fe_offers_agent_eligibility_amp = 'fe_offers_agent_eligibility_amp',
}

export interface FeatureFlag {
  name: FeatureFlagName;
  active: boolean;
}
